import { render, staticRenderFns } from "./DriverSearch.vue?vue&type=template&id=5de3543d&scoped=true&"
import script from "./DriverSearch.vue?vue&type=script&lang=js&"
export * from "./DriverSearch.vue?vue&type=script&lang=js&"
import style0 from "./DriverSearch.vue?vue&type=style&index=0&id=5de3543d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de3543d",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QTable});
